/* eslint-disable max-len */
import {
  Card, Box, Skeleton,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { UsersGroup } from '../../../../icons/users-group';
import { SystemStatisticsCardItem } from '../SystemStatisticsCardItem';
import { Filter } from '../../../../icons/filter';
import { Clock } from '../../../../icons/clock';
import { decimalToMinutesText } from '../../../../utils/date';
import style from './srtyle';

type GeneralSystemStatisticsSectionProps = {
  isLoading: boolean,
  usersData: UsersSystemStatistics | undefined,
  matchFlowsData: MatchFlowsSystemStatistics | undefined,
}

export default function GeneralSystemStatisticsSection({
  isLoading,
  usersData,
  matchFlowsData,
}: GeneralSystemStatisticsSectionProps): JSX.Element {
  const [wauCard, setWauCard] = useState<SystemStatisticsCard>({
    title: 'Last Week WAU',
    color: 'action.active',
    amount: '0',
    icon: (
      <UsersGroup
        viewBox={ style.icon.viewBox }
        sx={ style.icon.sx }
      />),
  });
  const [engineRunTimeCard, setEngineRunTimeCard] = useState<SystemStatisticsCard>({
    title: 'Engine Run Time',
    color: 'action.active',
    amount: '0',
    icon: (
      <Clock
        viewBox={ style.icon.viewBox }
        sx={ style.icon.sx }
      />),
  });
  const [lastMileFiltrationCard, setLastMileFiltrationCard] = useState<SystemStatisticsCard>({
    title: 'Last Mile Filteration',
    color: 'action.active',
    amount: '0',
    icon: (
      <Filter
        viewBox={ style.icon.viewBox }
        sx={ style.icon.sx }
      />),
  });

  useEffect(() => {
    if (!isLoading) {
      const runTimeText = decimalToMinutesText(Number(((matchFlowsData?.matchEngineAverageRunTime || 0) / 60).toFixed(2)));
      const updatedWauCard = { ...wauCard, amount: usersData?.lastWeekActiveUsersCount?.toString()  || '0' };
      const updatedEngineRunTimeCard = { ...engineRunTimeCard, amount: `${runTimeText} minutes` };
      const updatedLastMileFiltrationCard = { ...lastMileFiltrationCard, amount: `${((matchFlowsData?.lastMileAverageFiltrationPercent || 0))?.toFixed()}%` };
      setWauCard(updatedWauCard);
      setEngineRunTimeCard(updatedEngineRunTimeCard);
      setLastMileFiltrationCard(updatedLastMileFiltrationCard);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  const renderCard = (card: SystemStatisticsCard): JSX.Element => {
    if (isLoading) {
      return (
        <Skeleton
          width={ style.skeleton.width }
          height={ style.skeleton.height }
          variant={ style.skeleton.variant }
          sx={ style.skeleton.sx }
        />
      );
    }

    return (
      <SystemStatisticsCardItem
        icon={ card.icon }
        title={ card.title }
        amount={ card.amount }
        color={ card.color }
      />
    );
  };

  return (
    <Card sx={ style.containerCard }>
      <Box sx={ style.containerCardsBox }>
        { renderCard(wauCard) }
        { renderCard(engineRunTimeCard) }
        { renderCard(lastMileFiltrationCard) }
      </Box>
    </Card>
  );
}
